import { createSlice } from "@reduxjs/toolkit";

const vehiclesInits = {
  myVehicles: [],
  adminVehicles: [],
};

const reducers = {
  getUserVehiclesList: (state, action) => {
    const newItems = action.payload.items;

    state.myVehicles = newItems;
  },
  deleteUserVehicleItem: (state, action) => {
    const tempMyvehicles = [...state.myVehicles];
    const vehicleId = action.payload.id;

    const updatedLlist = tempMyvehicles.filter((item) => item.id !== vehicleId);

    state.myVehicles = updatedLlist;
  },
  getAdminVehiclesList: (state, action) => {
    const newItems = action.payload.items;

    state.adminVehicles = newItems;
  },
  deleteAdminVehicleItem: (state, action) => {
    const tempVehicles = [...state.adminVehicles];
    const vehicleId = action.payload.id;

    const updatedLlist = tempVehicles.filter((item) => item.id !== vehicleId);

    state.adminVehicles = updatedLlist;
  },
  // delteSpotsItem:(state,action) => {},
};

const vehiclesSlice = createSlice({
  name: "vehicles",
  initialState: vehiclesInits,
  reducers,
});

export const {
  getUserVehiclesList,
  deleteUserVehicleItem,
  getAdminVehiclesList,
  deleteAdminVehicleItem,
} = vehiclesSlice.actions;

export default vehiclesSlice.reducer;
